import React from 'react'
import './About.css'
import myImage_2 from '../../assets/myImage_3.jpg'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

function About() {
    return (
        <>
            <div className='container' style={{ marginTop: '-20px' }}>
                {/* stylish about me page for my portfolio which is containing photo*/}
                <div className="header-text-h1">
                    <h1 className='header-text'>About Me</h1>
                </div>
                <div className='row my-xl-5 my-lg-5 my-2 align-items-center'>
                    <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                        <div className='about-img-div'>
                            <img className='about-img' src={myImage_2} alt='Dharmesh Poriya' />
                        </div>
                    </div>
                    <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mx-xl-0  mx-lg-0 mx-md-0 mx-sm-3 mx-3 my-md-4 my-sm-4 my-4'>
                        <div className='about-text'>
                            {/* <h2>Hey there, I'm Dharmesh Poriya</h2> */}
                            <p>
                                Hi there! My name is Dharmesh Poriya, and I'm from Surat, Gujarat. I'm passionate about technology and the endless possibilities it offers, which is why I am always eager to explore new technologies.
                            </p><p>
                                I am <b>Software Development Engineer @Amazon</b>. I have also worked on various projects and have experience in working with different technologies like Java, Python, React, NodeJS, etc.
                            </p><p>
                                I am a quick learner and a team player. I am always ready to learn new things and work with new technologies. I am also a good problem solver and a versatile developer. I am always ready to take on new challenges and solve them.
                            </p>
                            <p>
                                Outside of work, I enjoy playing and watching cricket, badminton, table tennis, kabaddi, and chess. I also have a passion for reading and traveling to nature-filled destinations.
                            </p>
                        </div>
                    </div>
                </div>
                <div className='row mx-md-5 mb-sm-3 mb-2'>
                    <h1 style={{ textAlign: 'left' }}>Basic Information :</h1>
                    <div className='col-12 mt-2 px-4'>
                        <div className='row ml-4' style={{ textAlign: 'left' }}>
                            <div className='col-lg-6 col-md-6 col-12'>
                                <p><FontAwesomeIcon icon={faChevronRight} /><big><b> Birth Date : </b> </big>07 september 2003</p>
                            </div>
                            <div className='col-lg-6 col-md-6 col-12'>
                                <p><FontAwesomeIcon icon={faChevronRight} /><big><b> Age : </b> </big>21</p>
                            </div>
                        </div>
                        <div className='row' style={{ textAlign: 'left' }}>
                            <div className='col-lg-6 col-md-6 col-12'>
                                <p><FontAwesomeIcon icon={faChevronRight} /><big><b> Email : </b> </big><a style={{ textDecoration: 'none', color: 'blue' }} href='mailto:dharmeshkporiya@gmail.com'>Send mail</a></p>
                            </div>
                            <div className='col-lg-6 col-md-6 col-12'>
                                <p><FontAwesomeIcon icon={faChevronRight} /><big><b> City : </b> </big>Surat, Gujarat (India)</p>
                            </div>
                        </div>
                        <div className='row' style={{ textAlign: 'left' }}>
                            <div className='col-lg-6 col-md-6 col-12'>
                                <p><FontAwesomeIcon icon={faChevronRight} /><big><b> Website : </b> </big><a style={{ textDecoration: 'none', color: 'blue' }} href='https://dharmesh-poriya.netlify.app/'>Visit Portfolio</a></p>
                            </div>
                            <div className='col-lg-6 col-md-6 col-12'>
                                <p><FontAwesomeIcon icon={faChevronRight} /><big><b> Open to Work? : </b> </big>Available</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Footer /> */}
        </>
    )
}

export default About